import i18n from "@config/i18n";
import { Catalog } from "@models/ISchema";

export const CATEGORIES = () => ({
  students: i18n.t("home.action-cards.catalogs.categories.students"),
  academic_offer: i18n.t("home.action-cards.catalogs.categories.academic_offer"),
  teachers: i18n.t("home.action-cards.catalogs.categories.teachers"),
  infrastructure: i18n.t("home.action-cards.catalogs.categories.infrastructure"),
  programming_variables: i18n.t("home.action-cards.catalogs.categories.programming_variables"),
});

const catalogsCategories = () => ({
  students: {
    id: "students",
    category: CATEGORIES().students,
    description: i18n.t("home.action-cards.catalogs.options.students-description"),
  },
  student_registries: {
    id: "student_registries",
    category: CATEGORIES().students,
    description: i18n.t("home.action-cards.catalogs.options.student_registries-description"),
  },
  records: {
    id: "records",
    category: CATEGORIES().students,
    description: i18n.t("home.action-cards.catalogs.options.records-description"),
  },
  enrollments: {
    id: "enrollments",
    category: CATEGORIES().students,
    description: i18n.t("home.action-cards.catalogs.options.enrollments-description"),
  },
  sedes: {
    id: "sedes",
    category: CATEGORIES().academic_offer,
    description: i18n.t("home.action-cards.catalogs.options.sedes-description"),
  },
  escuelas: {
    id: "escuelas",
    category: CATEGORIES().academic_offer,
    description: i18n.t("home.action-cards.catalogs.options.escuelas-description"),
  },
  regimens: {
    id: "regimens",
    category: CATEGORIES().academic_offer,
    description: i18n.t("home.action-cards.catalogs.options.regimens-description"),
  },
  jornadas: {
    id: "jornadas",
    category: CATEGORIES().academic_offer,
    description: i18n.t("home.action-cards.catalogs.options.jornadas-description"),
  },
  carreras: {
    id: "carreras",
    category: CATEGORIES().academic_offer,
    description: i18n.t("home.action-cards.catalogs.options.carreras-description"),
  },
  curriculums: {
    id: "curriculums",
    category: CATEGORIES().academic_offer,
    description: i18n.t("home.action-cards.catalogs.options.curriculums-description"),
  },
  cursos: {
    id: "cursos",
    category: CATEGORIES().academic_offer,
    description: i18n.t("home.action-cards.catalogs.options.cursos-description"),
  },
  term_types: {
    id: "term_types",
    category: CATEGORIES().academic_offer,
    description: i18n.t("home.action-cards.catalogs.options.term_types-description"),
  },
  periodos: {
    id: "periodos",
    category: CATEGORIES().academic_offer,
    description: i18n.t("home.action-cards.catalogs.options.periodos-description"),
  },
  restricciones: {
    id: "restricciones",
    category: null,
  },
  levels: {
    id: "levels",
    category: CATEGORIES().academic_offer,
    description: i18n.t("home.action-cards.catalogs.options.levels-description"),
  },
  instructor_contract_types: {
    id: "instructor_contract_types",
    category: CATEGORIES().teachers,
    description: i18n.t("home.action-cards.catalogs.options.instructor_contract_types-description"),
  },
  profesors: {
    id: "profesors",
    category: CATEGORIES().teachers,
    description: i18n.t("home.action-cards.catalogs.options.profesors-description"),
  },
  "docente-asignaturas": {
    id: "docente-asignaturas",
    category: CATEGORIES().teachers,
    description: i18n.t("home.action-cards.catalogs.options.docente-asignaturas-description"),
  },
  "docente-disponibilidad": {
    id: "docente-disponibilidad",
    category: CATEGORIES().teachers,
    description: i18n.t("home.action-cards.catalogs.options.docente-disponibilidad-description"),
  },
  edificios: {
    id: "edificios",
    category: CATEGORIES().infrastructure,
    description: i18n.t("home.action-cards.catalogs.options.edificios-description"),
  },
  classroom_types: {
    id: "classroom_types",
    category: CATEGORIES().infrastructure,
    description: i18n.t("home.action-cards.catalogs.options.classroom_types-description"),
  },
  salas: {
    id: "salas",
    category: CATEGORIES().infrastructure,
    description: i18n.t("home.action-cards.catalogs.options.salas-description"),
  },
  edificios_distancia: {
    id: "edificios_distancia",
    category: CATEGORIES().infrastructure,
    description: i18n.t("home.action-cards.catalogs.options.edificios_distancia-description"),
  },
  categorias: {
    id: "categorias",
    category: CATEGORIES().programming_variables,
    description: i18n.t("home.action-cards.catalogs.options.categorias-description"),
  },
  asignaturas: {
    id: "asignaturas",
    category: CATEGORIES().programming_variables,
    description: i18n.t("home.action-cards.catalogs.options.asignaturas-description"),
  },
  demandas: {
    id: "demandas",
    category: CATEGORIES().programming_variables,
    description: i18n.t("home.action-cards.catalogs.options.demandas-description"),
  },
  bloques: {
    id: "bloques",
    category: CATEGORIES().programming_variables,
    description: i18n.t("home.action-cards.catalogs.options.bloques-description"),
  },
  stripes: {
    id: "stripes",
    category: CATEGORIES().programming_variables,
    description: i18n.t("home.action-cards.catalogs.options.stripes-description"),
  },
  semanas: {
    id: "semanas",
    category: CATEGORIES().programming_variables,
    description: i18n.t("home.action-cards.catalogs.options.semanas-description"),
  },
  "asignatura-semana": {
    id: "asignatura-semana",
    category: CATEGORIES().programming_variables,
    description: i18n.t("home.action-cards.catalogs.options.asignatura-semana-description"),
  },
  restricciones_asignatura_edificio: {
    id: "restricciones_asignatura_edificio",
    category: CATEGORIES().programming_variables,
    description: i18n.t(
      "home.action-cards.catalogs.options.restricciones_asignatura_edificio-description",
    ),
  },
});

export const getCatalogCategory = (catalog: Catalog) => {
  return {
    ...catalog,
    label: i18n.t("home.action-cards.catalogs.options." + catalog.id, catalog?.label ?? ""),
    category: catalogsCategories()?.[catalog.id]?.category || null,
    description: catalogsCategories()?.[catalog.id]?.description || null,
  };
};
